import { render, staticRenderFns } from "./InvestorsArchive.vue?vue&type=template&id=7abde462"
import script from "./InvestorsArchive.vue?vue&type=script&lang=js"
export * from "./InvestorsArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports